module.exports = __webpack_public_path__ + "img/3About.ec794809.png";